@if (loaded) {
    <div class="audit-risk-assessment">
        <div class="left-block">
            @if (risksConfig) {
                <generic-list-manager [config]="risksConfig"></generic-list-manager>
            }

            @if (controlsConfig) {
                <generic-list-manager [config]="controlsConfig"></generic-list-manager>
            }
        </div>

        <div class="right-block">
            <div class="detail-page-card">
                <div class="detail-page-card-title">
                    <span>Risk Assessment</span>
                </div>
                <div class="detail-page-card-body padded form-group-styling">
                    <cerrix-custom-fields-editor
                        [parentForm]="riskAssessmentFormGroup"
                        [customFieldData]="customFieldData"
                        emptyMessage="No risk assessment fields are defined for this Audit Type."
                    >
                    </cerrix-custom-fields-editor>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
